// @ts-check
import ProviderModal from './ProviderModal';

export default ProviderModal;
